'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Drawer, DrawerContent, DrawerTitle, DrawerTrigger } from '@achra/ui/drawer';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { WalletIcon } from 'lucide-react';
import type { OpHubMember } from '@/modules/__generated__/graphql/switchboard-generated';
import { useBuilderDrawerState } from '../../hooks/use-builder-drawer-state';
import { ProfileFinancesCardContent } from '../profile-finances-card-content';
interface ProfileFinancesDrawerProps {
  builderSlug: string;
  operationalHub: OpHubMember;
}
function ProfileFinancesDrawer(t0) {
  const $ = _c(9);
  const {
    builderSlug,
    operationalHub
  } = t0;
  const [open, setOpen] = useBuilderDrawerState();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DrawerTrigger asChild={true}><Button variant="ghost" size="icon" aria-label="View finances links" className="sm:bg-secondary sm:size-13.5 sm:rounded-xl sm:border-2"><WalletIcon className="size-4" /></Button></DrawerTrigger>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <VisuallyHidden><DrawerTitle>Finances</DrawerTitle></VisuallyHidden>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== builderSlug || $[3] !== operationalHub) {
    t3 = <DrawerContent>{t2}<div className="px-4 pb-8"><ProfileFinancesCardContent builderSlug={builderSlug} operationalHub={operationalHub} /></div></DrawerContent>;
    $[2] = builderSlug;
    $[3] = operationalHub;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== open || $[6] !== setOpen || $[7] !== t3) {
    t4 = <Drawer open={open} onOpenChange={setOpen}>{t1}{t3}</Drawer>;
    $[5] = open;
    $[6] = setOpen;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export { ProfileFinancesDrawer };